import { TextField } from "@mui/material";

const RangeComponent = (props) => {
  const { question } = props;
  return (
    <>
      <TextField
        id={question._id}
        fullWidth={true}
        //value={question.userAnswer}
        type="number"
        placeholder={
          question.tooltip !== ""
            ? question.questiond.tooltip
            : question.answers[0].text + " - " + question.answers[1].text
        }
        onChange={(event) => {}}
        variant="outlined"
      />
      {question?.questiond?.helpPage !== undefined && (
        <a href="#">
          <div style={{ width: "100%", textAlign: "right" }}>
            {question.helpText}
          </div>
        </a>
      )}
    </>
  );
};
export default RangeComponent;
